__turbopack_context__.v({
  "elevateInfoContainer": "_-module__ceveTG__elevateInfoContainer",
  "fade": "_-module__ceveTG__fade",
  "propositionContainer": "_-module__ceveTG__propositionContainer",
  "scheduleContainer": "_-module__ceveTG__scheduleContainer",
  "scheduleList": "_-module__ceveTG__scheduleList",
  "textGradient1": "_-module__ceveTG__textGradient1",
  "textGradient2": "_-module__ceveTG__textGradient2",
  "textGradient3": "_-module__ceveTG__textGradient3",
});
